import { isSlovakStore } from '@eliadmin/core/src/constants/store';

function getLocalizedRoute(slug: { sk: string; de: string }) {
  return isSlovakStore() ? slug.sk : slug.de;
}

export const ROUTES_OVERRIDES = {
  THANK_YOU: () => getLocalizedRoute({ sk: '/dakujeme', de: '/danke' }),
  SERVICES: () => getLocalizedRoute({ sk: '/sluzby', de: '/dienstleistungen' }),
  ABOUT: () => getLocalizedRoute({ sk: '/o-nas', de: '/ueber-uns' }),
  REFERENCES: () => getLocalizedRoute({ sk: '/realizacie', de: '/referenzen' }),
};
